import AnalyticsV2Context from './hooks/useAnalyticsContext'
import {AnalyticsV2Controller} from '.'

export const AnalyticsV2Provider = ({children}) => {
  const analytics = AnalyticsV2Controller()
  return <AnalyticsV2Context.Provider value={analytics}>{children}</AnalyticsV2Context.Provider>
}
